import { render, staticRenderFns } from "./message-tip.vue?vue&type=template&id=b4311654&"
import script from "./message-tip.vue?vue&type=script&lang=js&"
export * from "./message-tip.vue?vue&type=script&lang=js&"
import style0 from "./message-tip.vue?vue&type=style&index=0&id=b4311654&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports